import axios from './index'

export default {
  fetchAll(params) {
    return axios.get('/api/v1/place/typology', { params })
  },
}